var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isFlyrollClosed)?_c('NoSSR',[_c('AdvCreative',{ref:"advCreative",attrs:{"adv":_vm.advData,"clientRender":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }